import { render, staticRenderFns } from "./info-dialog.vue?vue&type=template&id=ad24e7cc&"
import script from "./info-dialog.vue?vue&type=script&lang=js&"
export * from "./info-dialog.vue?vue&type=script&lang=js&"
import style0 from "./info-dialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "info-dialog.vue"
export default component.exports